const routes = [
    {
        path: "/medicine/groups",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "medicinegroup_index",
        }
    }
];

export default routes;
